(function() {
    'use strict';
    angular
        .module('doctorclubboApp')
        .factory('Statement', Statement);

    Statement.$inject = ['$resource', 'DateUtils'];

    function Statement ($resource, DateUtils) {
        var resourceUrl =  'api/statements/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dtIns = DateUtils.convertDateTimeFromServer(data.dtIns);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
